import {
  Route,
  Routes,
  RoutesProps,
} from "react-router-dom";

import React, { Suspense } from "react";
import ForgotPassword from "../components/Login/ForgotPassword";
import Main from "../components/Main";
import ProtectedRoute from "./ProtectedRoute";
import { CategoryProvider } from "../context/CategoryContext";
import { SubCategoryProvider } from "../context/SubCategoryContext";
import { DineInTableProvider } from "../context/DineInTableContext";
import { KitchenProvider } from "../context/KitchenContext";

const Navigation = () => {
  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));

  // POS pages ----------------------
  const Dashboard = React.lazy(() => import("../POS/Dashboard/Dashboard"));
  const KDS = React.lazy(() => import("../POS/KDS/Kds"));
  const TrackOrderTable = React.lazy(() => import("../POS/Dashboard/Tabs/TabOrderTracking/TrackOrderDetails"))
  const EditOrderDetails = React.lazy(() => import("../POS/Dashboard/Tabs/TabOrderTracking/EditTrackOrderDetails"))

  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route
            path="/login"
            element={
              <Suspense fallback={<></>}>
                <Login />
              </Suspense>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <Suspense fallback={<></>}>
                <ForgotPassword />
              </Suspense>
            }
          />

          <Route path="/" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<Main />} />} >
            {/* POS Routes  */}
            <Route path="/pos/dashboard" element={<Suspense fallback={<></>}> <CategoryProvider>
              <SubCategoryProvider>
                <DineInTableProvider>
                  <Dashboard />
                </DineInTableProvider>
              </SubCategoryProvider>
            </CategoryProvider> </Suspense>} />
            <Route path="/pos/kds" element={<Suspense fallback={<></>}>
              <KitchenProvider>
                <KDS />
              </KitchenProvider>
            </Suspense>} />
            <Route path="/pos/order-details/:id" element={<Suspense fallback={<></>}>
              <TrackOrderTable />
            </Suspense>} />
            <Route path="/pos/edit-order-details/:id" element={<Suspense fallback={<></>}>
              <EditOrderDetails />
            </Suspense>} />
          </Route>

        </Routes >
      </div >
    </>
  );
};

export default Navigation;
